import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  parametros: []
});

function parametroReducer(state = initialState, action) {
  switch (action.type) {
    case types.PARAMETRO_ALL_START: {
      return startLoad(state);
    }

    case types.PARAMETRO_ALL_SUCCESS: {
      return endLoad(state.set('parametros', fromJS(action.payload)));
    }

    case types.PARAMETRO_ALL_ERROR: {
      return endLoad(state);
    }
  }

  return state;
}

export default parametroReducer;
